import { render, staticRenderFns } from "./CourseMegaMenu.vue?vue&type=template&id=766f4059&scoped=true&"
import script from "./CourseMegaMenu.vue?vue&type=script&lang=js&"
export * from "./CourseMegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./CourseMegaMenu.vue?vue&type=style&index=0&id=766f4059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f4059",
  null
  
)

export default component.exports